import { createContext } from 'react'

const TeamContext = createContext()
const PickContext = createContext()

export { TeamContext, PickContext }
